export default __webpack_public_path__ + "static/SamsungOne-400-91aad41df9a0a033f0205001427fa71d.ttf";